import { render, staticRenderFns } from "./key-figure.vue?vue&type=template&id=5c820df0"
import script from "./key-figure.vue?vue&type=script&lang=js"
export * from "./key-figure.vue?vue&type=script&lang=js"
import style0 from "./key-figure.vue?vue&type=style&index=0&id=5c820df0&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c820df0')) {
      api.createRecord('5c820df0', component.options)
    } else {
      api.reload('5c820df0', component.options)
    }
    module.hot.accept("./key-figure.vue?vue&type=template&id=5c820df0", function () {
      api.rerender('5c820df0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/components/key-figure.vue"
export default component.exports